import { useToast } from "@/hooks/use-toast";
import { useCallback, useState } from "react";
import { buildAuthorizeUrl } from "../../auth/pkce";
import Button from "../button";
import Loader from "../loader";

const LoginForm = () => {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleLogin = useCallback(
    async (e) => {
      e.preventDefault();
      setLoading(true);

      try {
        const authorizeUrl = await buildAuthorizeUrl();
        window.location.href = authorizeUrl;
      } catch (err) {
        console.log("Error:", err);
        toast({
          title: "Error!",
          description: `Something went wrong. ${err.message}`,
          variant: "destructive",
        });
        setLoading(false);
      }
    },
    [toast],
  );

  return (
    <div className="relative max-w-md mx-auto p-6">
      {loading && <Loader />}
      <div className="text-center">
        <p className="text-sm mb-6 text-subtle">
          Sign in to your account via our secure authentication service.
        </p>
        <Button type="button" disabled={loading} onClick={handleLogin}>
          Sign in with vizOps
        </Button>
      </div>
    </div>
  );
};

export default LoginForm;
